/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDataDialogPromptResponseContent
 */
export interface CreateDataDialogPromptResponseContent {
    /**
     * 
     * @type {string}
     * @memberof CreateDataDialogPromptResponseContent
     */
    message?: string;
}


/**
 * Check if a given object implements the CreateDataDialogPromptResponseContent interface.
 */
export function instanceOfCreateDataDialogPromptResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateDataDialogPromptResponseContentFromJSON(json: any): CreateDataDialogPromptResponseContent {
    return CreateDataDialogPromptResponseContentFromJSONTyped(json, false);
}

export function CreateDataDialogPromptResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDataDialogPromptResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function CreateDataDialogPromptResponseContentToJSON(value?: CreateDataDialogPromptResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

